<template>
    <div>
        <div class="about" :class="{ active: animate }">
      <div class="aboutHeader">
        <img
          src="../../../../assets/logistics/logistics.jpg"
          alt="aboutHeader"
          id="aboutHeaderImage"
        />
      </div>
      <div class="top-left">
        <h1 class="drop-from-top">
           CCS in Logistics 
        </h1>
        <p class="drop-from-bottom">
          Transforming Logistics with Tailored ERP Solutions: Our Role as an Oracle Partner
        </p>
      </div>
    </div>
    </div>
</template>

<script src="./first.js"></script>
<style src="./first.css"></style>